/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import md5 from 'crypto-js/md5';
import DropDownMenu from '../../../../Form/DropDownMenu';
import TagsInput from '../../../StructureComponents/TagsInput';
import StreamItems from './StreamItems';
import BasicParagraphPSWorld from './PWSupportingComponents/BasicParagraphPSWorld';
import ZoneItems from './ZoneItems';
import ChatConfigModule from './chat/ChatConfigModule';
import Modal from '../../../../Modal/Modal';
import LoadIcon from '../../../../LoadIcon';
import DateAndTimePicker from '../../../../Form/DateAndTimePicker';
import ensureFirebaseAuth from '../../../../../firebase/ensureFirebaseAuth';
import { channelsRef } from '../../../../../firebase';

import SingleObjUploaderWithSelector from '../../../Mam/SingleObjUploaderWithSelector';
import imageModifier from '../../../../../utils/imageModifier';
// import checkPostSlugNameRepeated from '../../../../../utils/checkPostSlugNameRepeated';


const videoSources = [
  { text: 'RESET', value: '' },
  { text: 'vimeo', value: 'vimeo' },
  { text: 'cover', value: 'cover' },
  { text: 'finalCover', value: 'finalCover' },
  { text: 'lowDash', value: 'lowDash' },
  { text: 'youtube', value: 'youtube' },
  // { text: 'dash', value: 'dash' },
];

const initialState = {
  type: 'StreamModule',
  addeventId: '',
  chatChannelID: '',
  qaChannelID: '',
  moderators: [],
  chatRules: {
    show: false,
    en: '<p>To learn more about the chat visit this <a href="https://www.onps.pro/pro-online/how-the-chat-works" target="_blank" text-decoration: underline">link</a>.</p>',
    es: '<p>Para saber más sobre el chat pincha <a href="https://www.onps.pro/pro-online/how-the-chat-works" target="_blank" text-decoration: underline">aquí</a></p>',
    ca: '<p>Per saber més sobre el xat punxa <a href="https://www.onps.pro/pro-online/how-the-chat-works" target="_blank" text-decoration: underline">aquí</a></p>',
  },
  coverImageUrl: '',
  initialCoverImage: {
    en: '',
    es: '',
    ca: '',
    pt: '',
  },
  finalCoverImage: {
    en: '',
    es: '',
    ca: '',
    pt: '',
  },
  source: '',
  streamStartDateAndTime: null,
  streamEndDateAndTime: null,
  initialSource: 'cover',
  finalSource: 'vimeo',
  finalSourceCover: 'finalCover',
  smalHlsVideoUrl: '',
  requiredRole: '',
  streamObjects: [],
  intro: {
    title: 'Video Chat Rooms',
    text: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
  },
  zones: [],
};

const StreamModule = ({
  handlerSetComponents, components, id, reusableComponent, languages, activeLanguage, match,
}) => {
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingChannels, setIsLoadingChannels] = useState(false);
  const [isLoadingChannelsQa, setIsLoadingChannelsQa] = useState(false);
  const [isModalOpen, setModalState] = useState(false);
  const [modalTitle, setModalTitle] = useState('Create new channel');
  const [channelList, setChannelList] = useState([]);
  const [showChannelList, setShowChannelList] = useState(false);
  const [showChannelListForQa, setShowChannelListForQa] = useState(false);
  const [activeChannelType, setActiveChannelType] = useState(null);
  const [isInitialImageModalOpen, setInitialImageModalState] = useState(false);
  const [isFinalImageModalOpen, setFinalImageModalState] = useState(false);
  const [activeLang, setActiveLanguage] = useState('');
  const [visibleLangImageInitial, setSelectedImageInitial] = useState({
    en: '',
    es: '',
    ca: '',
    pt: '',
  });
  const [visibleLangImageFinal, setSelectedImageFinal] = useState({
    en: '',
    es: '',
    ca: '',
    pt: '',
  });

  const getChannelList = () => {
    if (activeChannelType === 'chatChannelID') {
      setIsLoadingChannels(true);
    } else if (activeChannelType === 'qaChannelID') {
      setIsLoadingChannelsQa(true);
    }
    channelsRef.where('channelPrivacy', '==', 'open').get().then((snapshots) => {
      const { docs } = snapshots;
      if (docs.length) {
        const channels = docs.map(doc => doc.data());
        setChannelList(channels);
        if (activeChannelType === 'chatChannelID') {
          setIsLoadingChannels(false);
        } else if (activeChannelType === 'qaChannelID') {
          setIsLoadingChannelsQa(false);
        }
      }
    });
  };

  const handleShowChannelList = async (name) => {
    if (!showChannelList && !showChannelListForQa) {
      if (name === 'chatChannelID') {
        setShowChannelList(true);
      } else {
        setShowChannelListForQa(true);
      }
      setActiveChannelType(name);
      await getChannelList();
    } else {
      setShowChannelList(false);
      setShowChannelListForQa(false);
    }
  };

  const setChannel = (value) => {
    const { component } = components[index];
    const comp = {
      ...component,
      [activeChannelType]: value,
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    setShowChannelList(false);
    setShowChannelListForQa(false);
    setActiveChannelType(null);
    handlerSetComponents(componentObj, index);
  };

  const addModerator = (name) => {
    let mods = [];
    if (state.moderators) {
      mods = [...state.moderators];
    }
    const hashedName = md5(name).toString();
    mods.push(hashedName);
    const newState = {
      ...state,
      moderators: mods,
    };
    const componentObj = {
      id,
      component: newState,
    };

    setState(newState);
    handlerSetComponents(componentObj, index);
  };

  const removeModerator = (hashedName) => {
    const mods = [...state.moderators];
    const moderatorIndex = mods.indexOf(hashedName);
    mods.splice(moderatorIndex, 1);
    const newState = {
      ...state,
      moderators: mods,
    };
    const componentObj = {
      id,
      component: newState,
    };

    setState(newState);
    handlerSetComponents(componentObj, index);
  };

  const toggleModal = () => {
    setModalState(!isModalOpen);
  };

  const handlerSetStreamUrls = (streamObjects) => {
    const newState = {
      ...state,
      streamObjects,
    };
    setState(newState);
    const componentObj = {
      id,
      component: newState,
    };
    handlerSetComponents(componentObj, index);
  };

  const inputHandler = (e, section = null) => {
    const { value, name } = e.target;
    const { component } = components[index];

    let comp;

    if (section) {
      comp = {
        ...component,
        [section]: {
          ...component[section],
          [name]: value,
        },

      };
    } else {
      comp = {
        ...component,
        [name]: value,
      };
    }


    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const storeOptionItemLayout = (opt, name) => {
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: opt,
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const inputHandlerByLanguage = (contentHtml, name, lang, section) => {
    let comp;
    if (section) {
      comp = {
        ...state,
        [section]: {
          ...state[section],
          [name]: {
            ...state[section][name],
            [lang.toLowerCase()]: contentHtml,
          },
        },
      };
    } else {
      comp = {
        ...state,
        [name]: {
          ...state[name],
          [lang.toLowerCase()]: contentHtml,
        },
      };
    }

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const toggleShowChatRules = (show) => {
    const comp = {
      ...state,
      chatRules: {
        ...state.chatRules,
        show,
      },
    };
    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const handleInputIntro = (contentHtml, lang) => {
    if (index >= 0) {
      inputHandlerByLanguage(contentHtml, 'text', lang, 'intro');
    }
  };
  const handleChatRules = (contentHtml, lang) => {
    if (index >= 0) {
      inputHandlerByLanguage(contentHtml, 'chatRules', lang);
    }
  };

  const handlerSetStreamZones = (zones) => {
    const newState = {
      ...state,
      zones,
    };
    setState(newState);
    const componentObj = {
      id,
      component: newState,
    };
    handlerSetComponents(componentObj, index);
  };

  const handleDate = (name, date) => {
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: date,
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const toggleImageModalInitial = (lang) => {
    setActiveLanguage(lang);
    setInitialImageModalState(prevState => !prevState);
  };
  const toggleImageModalFinal = (lang) => {
    setActiveLanguage(lang);
    setFinalImageModalState(prevState => !prevState);
  };

  const setImageInitial = ([obj]) => {
    const { component } = components[index];
    toggleImageModalInitial();
    const newImage = {
      ...visibleLangImageInitial,
      [activeLang]: obj.objectUrl,
    };
    setSelectedImageInitial(newImage);
    const comp = {
      ...component,
      initialCoverImage: {
        ...component.initialCoverImage,
        [activeLang.toLowerCase()]: obj.url,
      },
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const setImageFinal = ([obj]) => {
    const { component } = components[index];
    toggleImageModalFinal();
    const newImage = {
      ...visibleLangImageFinal,
      [activeLang]: obj.objectUrl,
    };
    setSelectedImageFinal(newImage);
    const comp = {
      ...component,
      finalCoverImage: {
        ...component.finalCoverImage,
        [activeLang.toLowerCase()]: obj.url,
      },
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      let newComp = component;
      if (!component.chatRules) {
        newComp = {
          ...component,
          chatRules: {
            show: false,
            en: '<p>To learn more about the chat visit this <a href="https://www.onps.pro/pro-online/how-the-chat-works" target="_blank" text-decoration: underline">link</a>.</p>',
            es: '<p>Para saber más sobre el chat pincha <a href="https://www.onps.pro/pro-online/how-the-chat-works" target="_blank" text-decoration: underline">aquí</a></p>',
            ca: '<p>Per saber més sobre el xat punxa <a href="https://www.onps.pro/pro-online/how-the-chat-works" target="_blank" text-decoration: underline">aquí</a></p>',
          },
        };
      }
      if (!component.zones) {
        newComp = {
          ...component,
          zones: [],
        };
      }
      setState(newComp);
      const componentObj = {
        id,
        component: newComp,
      };
      handlerSetComponents(componentObj, componentIndex);
      setIsLoading(false);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      setIsLoading(false);
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  useEffect(() => {
    const { params: { slugName } } = match;

    // Shared with the online-users presence hook: one Firebase session per
    // post, signed in with this post's chat moderator claims.
    ensureFirebaseAuth(slugName);
  }, []);

  return (
    <>
      {!isLoading && (
      <div className="w-full px-5 rounded-lg flex flex-col pt-4 pb-4">
        <div className="pl-9 w-full">
          <button
            type="button"
            onClick={toggleModal}
            className="font-americaMonoBold text-xs pl-10 pr-6 py-1 h-7 my-1 rounded-full uppercase bg-greyFilter flex items-center"
          >
            Create new chat
            <span className="font-icon icon-add-button text-base pl-2" />
          </button>
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="chatChannelID">
              Chat channel id
              <div className="flex justify-between relative">
                <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 mx-1 p-1 text-sm" onChange={inputHandler} name="chatChannelID" type="text" value={state.chatChannelID || ''} />
                <button
                  type="button"
                  className="h-7 w-40 bg-white justify-center font-americaMonoBold p-1 text-xs rounded-full uppercase flex items-center cursor-pointer"
                  onClick={() => handleShowChannelList('chatChannelID')}
                >
                  {!showChannelList ? 'list' : 'close'}
                </button>
                {showChannelList && <ChannelListComponent isLoadingChannels={isLoadingChannels} channelList={channelList} setChannel={setChannel} /> }
              </div>
            </label>
          </div>
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="desktopVideoUrl">
              QA channel id
              <div className="flex justify-between relative">
                <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 mx-1 p-1 text-sm" onChange={inputHandler} name="qaChannelID" type="text" value={state.qaChannelID || ''} />
                <button
                  type="button"
                  className="h-7 w-40 justify-center bg-white font-americaMonoBold p-1 text-xs rounded-full uppercase flex items-center cursor-pointer"
                  onClick={() => handleShowChannelList('qaChannelID')}
                >
                  {!showChannelListForQa ? 'list' : 'close'}
                </button>
                {showChannelListForQa && <ChannelListComponent isLoadingChannels={isLoadingChannelsQa} channelList={channelList} setChannel={setChannel} /> }
              </div>
            </label>
          </div>
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <TagsInput toggleTag={addModerator} title="Moderator email" classes="mt-8px h-36px" />
            <div className="flex flex-wrap w-full mt-2">{state && state.moderators && state.moderators.map(tag => <ActiveTag key={tag} callback={removeModerator} title={tag} />)}</div>
          </div>
          <div className="bg-greyFilter w-full sm:w-full md:w-full">
            <label htmlFor="bySlugNames" className="flex items-center pt-0 ml-4 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular">
              Show chat rules
              <label className="switch mb-0 pb-0 h-6 ml-1">
                <input
                  name="chatRules"
                  checked={!state.chatRules.show}
                  onChange={e => toggleShowChatRules(!state.chatRules.show)}
                  type="checkbox"
                  id="switch-button"
                />
                <div className="switch-slider btn-yn switch-round" />
              </label>
            </label>
            {state && state.chatRules && state.chatRules.show
              ? (
                <BasicParagraphPSWorld
                  title="Chat rules"
                  handleInput={handleChatRules}
                  activeLanguage={activeLanguage}
                  languages={languages}
                  stateField={(state && state.hasOwnProperty('chatRules') && state.chatRules) || undefined}
                />
              )
              : null }
          </div>
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="addeventId">
              ADD Event Id (not the https only the ID)
              <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={inputHandler} name="addeventId" type="text" value={state.addeventId || ''} />
            </label>
          </div>
          <div className="bg-greyFilter w-full sm:w-full md:w-full pt-4 px-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="videoSource">
              DEFAULT! source type
              <DropDownMenu style="my-6px" menuTitle="itemLayout" text="" action="unique" menuItems={videoSources} onHandleChange={opt => storeOptionItemLayout(opt, 'source')} arr={state.source ? [state.source] : []} />
            </label>
          </div>
          <div className="w-full flex">
            <div className="bg-greyFilter w-1/2 sm:w-full md:w-full pt-4 px-4">
              <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2 w-full" htmlFor="dateAndTime">
                <DateAndTimePicker dateParse titleColor="black" title="Stream START date and time" name="streamStartDateAndTime" handleDate={handleDate} existingDate={state && state.streamStartDateAndTime} action="modify" wFull />
              </label>
            </div>
            <div className="bg-greyFilter w-1/2 sm:w-full md:w-full pt-4 px-4">
              <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2 w-full" htmlFor="dateAndTime">
                <DateAndTimePicker dateParse titleColor="black" title="Stream END date and time" name="streamEndDateAndTime" handleDate={handleDate} existingDate={state && state.streamEndDateAndTime} action="modify" wFull />
              </label>
            </div>
          </div>

          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="coverImageUrl">
              (OLD VERSION) Cover Image Url
              <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={inputHandler} name="coverImageUrl" type="text" value={state.coverImageUrl || ''} />
            </label>
          </div>

          <div className="w-full flex">
            <div className="bg-greyFilter w-1/3 sm:w-full md:w-full pt-4 px-4">
              <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="vdeoSourceInitial">
                Initial video source
                <DropDownMenu style="my-6px" menuTitle="itemLayout" text="" action="unique" menuItems={videoSources} onHandleChange={opt => storeOptionItemLayout(opt, 'initialSource')} arr={state.initialSource ? [state.initialSource] : []} />
              </label>
            </div>
            <div className="bg-greyFilter w-1/3 sm:w-full md:w-full pt-4 px-4">
              <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="vdeoSourceFinal">
                Final video source
                <DropDownMenu style="my-6px" menuTitle="itemLayout" text="" action="unique" menuItems={videoSources} onHandleChange={opt => storeOptionItemLayout(opt, 'finalSource')} arr={state.finalSource ? [state.finalSource] : []} />
              </label>
            </div>
            <div className="bg-greyFilter w-1/3 sm:w-full md:w-full pt-4 px-4">
              <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="vdeoSourceMiddle">
                Final cover source
                <DropDownMenu style="my-6px" menuTitle="itemLayout" text="" action="unique" menuItems={videoSources} onHandleChange={opt => storeOptionItemLayout(opt, 'finalSourceCover')} arr={state.finalSourceCover ? [state.finalSourceCover] : []} />
              </label>
            </div>
          </div>
          <div className="flex my-2">
            <>
              <div className={`xxl1:w-1/4 px-2 xxl1:ml-2 -mt-4 flex items-center flex-col ${state && state.initialCoverImage && state.initialCoverImage[activeLanguage] ? 'justify-evenly' : 'justify-center'}`}>
                <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-black text-white mt-4 whitespace-pre" type="button" onClick={() => toggleImageModalInitial(activeLanguage)}>
                  Select initial image
                </button>
                <div className="image">{state && state.initialCoverImage && state.initialCoverImage[activeLanguage] ? !state.initialCoverImage[activeLanguage].includes('svg') ? <img src={imageModifier(state.initialCoverImage[activeLanguage], '100x100')} /> : <img src={state.initialCoverImage[activeLanguage]} height="100" width="100" /> : null}</div>
              </div>
              {isInitialImageModalOpen && (
              <Modal handleClick={toggleImageModalInitial} positionMiddle>
                <SingleObjUploaderWithSelector selectCallback={setImageInitial} />
              </Modal>
              )}
            </>
            <>
              <div className={`xxl1:w-1/4 px-2 xxl1:ml-2 -mt-4 flex items-center flex-col ${state && state.finalCoverImage && state.finalCoverImage[activeLanguage] ? 'justify-evenly' : 'justify-center'}`}>
                <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-black text-white mt-4 whitespace-pre" type="button" onClick={() => toggleImageModalFinal(activeLanguage)}>
                  Select final image
                </button>
                <div className="image">{state && state.finalCoverImage && state.finalCoverImage[activeLanguage] ? !state.finalCoverImage[activeLanguage].includes('svg') ? <img src={imageModifier(state.finalCoverImage[activeLanguage], '100x100')} /> : <img src={state.finalCoverImage[activeLanguage]} height="100" width="100" /> : null}</div>
              </div>
              {isFinalImageModalOpen && (
              <Modal handleClick={toggleImageModalFinal} positionMiddle>
                <SingleObjUploaderWithSelector selectCallback={setImageFinal} />
              </Modal>
              )}
            </>

          </div>
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="mobileVideoUrl">
              Mobile HLS Url
              <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={inputHandler} name="smalHlsVideoUrl" type="text" value={state.smalHlsVideoUrl || ''} />
            </label>
          </div>
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="mobileVideoUrl">
              Required Role (leave blank by default)
              <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={inputHandler} name="requiredRole" type="text" value={state.requiredRole || ''} />
            </label>
          </div>
          <h2 className="w-full font-americaMonoRegular text-xs uppercase text-black mt-4 mb-2">
            Stream objects
          </h2>
          {languages.map(lang => (
            <div key={lang} className={`w-full ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'}`}>
              {(!isLoading || state.streamObjects.length) && <StreamItems handlerSetComponentsInParent={handlerSetStreamUrls} components={state.streamObjects} lang={lang} />}
            </div>
          ))}
        </div>
      </div>
      )}
      <div className="w-full px-5 rounded-lg flex pt-4 pb-4">
        <div className="pl-9 w-full">

          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="title">
              General title
              <input
                className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm"
                onChange={e => (inputHandler(e, 'intro'))}
                name="title"
                type="text"
                value={(state && state.hasOwnProperty('intro') && state.intro.title) || ''}
              />
            </label>
          </div>

          <BasicParagraphPSWorld
            title="General description"
            handleInput={handleInputIntro}
            activeLanguage={activeLanguage}
            languages={languages}
            stateField={(state && state.hasOwnProperty('intro') && state.intro.text) || undefined}
          />

          <h2 className="w-full font-americaMonoRegular text-xs uppercase text-black mt-4 mb-2">
            Video Chat Rooms
          </h2>
          {((!isLoading || state.zones.length) && state.zones) && <ZoneItems handlerSetComponentsInParent={handlerSetStreamZones} components={state.zones} languages={languages} activeLanguage={activeLanguage} />}
        </div>

      </div>
      {isModalOpen && (
      <Modal title={modalTitle} handleClick={toggleModal} type="modify">
        <ChatConfigModule setModalTitle={setModalTitle} />
      </Modal>
      )}
    </>
  );
};

StreamModule.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
  activeLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
StreamModule.defaultProps = {
  reusableComponent: null,
};

export default withRouter(StreamModule);

const ChannelListComponent = ({ channelList, setChannel, isLoadingChannels }) => (
  <div className="absolute pin-r z-top w-2/3 pin-t mt-4">
    {
 !isLoadingChannels && channelList ? (
   <div className="overflow-y-auto">
     <p className="font-americaMonoBold text-xs uppercase py-1 bg-greyFilter rounded-t-lg mr-4 ml-6 pl-5 mt-3 mb-0">Open channels</p>
     <div className="max-h-150 overflow-auto bg-greyFilterItems rounded-b-lg ml-6 mr-4 py-1 mb-3">
       {
        channelList.length > 0 ? channelList.map(element => (
          element && (
          <div onClick={() => setChannel(element.url)} key={element.url}>
            <p className="text-black font-americaMonoRegular outline-none w-full pl-6 my-1">{element.name }</p>
          </div>
          )
        )) : null
     }
     </div>
   </div>
 ) : (
   <div className="py-1 bg-greyFilter rounded-t-lg mr-4 ml-6 pl-5 mt-3 mb-0">
     <LoadIcon />
   </div>
 )
}
  </div>
);

const ActiveTag = ({ title, callback }) => (
  <span className="cursor-pointer bg-white py-1 px-2 mr-2 mb-2 font-americaMono text-xs rounded-lg flex items-center uppercase text-black">
    <div className="flex justify-center" onClick={() => (callback ? callback(title) : null)}>
      {callback ? 'X' : ''}
      {' '}
      {title}
    </div>
  </span>
);
